import React from "react";
import { Container, Item, Underline } from "./TabSlider.styled";
import { useScrollIntoView } from "../Tabs/utils";

export interface TabSliderOptionsProps {
  index: number;
  title: string;
  value: string;
}

export interface TabSliderProps {
  inactiveTextColor?: string;
  options: TabSliderOptionsProps[];
  defaultIndex?: number;
  onClick?: (item: TabSliderOptionsProps) => void;
  isOnModal?: boolean;
  isModalVisible?: boolean;
  defaultIndexCardLeftSpace?: number;
}

const TabSlider: React.FC<TabSliderProps> = ({
  options = [],
  defaultIndex = 0,
  onClick,
  inactiveTextColor,
  isOnModal,
  isModalVisible,
  defaultIndexCardLeftSpace = 0,
}) => {
  const wrapperRef = React.useRef<HTMLDivElement | null>(null);
  const averageWidth = React.useRef(0);

  const [activeTab, setActiveTab] = React.useState<number>(0);
  const [arrayOfTabWidth, setArrayOfTabWidth] = React.useState([]);

  const { scrollTo } = useScrollIntoView();

  const handleClick = React.useCallback(
    (index: number) => {
      if (wrapperRef?.current) {
        //   @ts-ignore
        const _left = Number(arrayOfTabWidth?.[index]?.width ?? 0);

        scrollTo({
          top: 0,
          left: _left,
          horizontal: true,
          averageWidth: averageWidth?.current + 10,
          scrollableContainer: wrapperRef?.current,
          errorCallback: () => {
            onClick?.(options?.[index]);
            setActiveTab(Number(index));
          },
        })?.then((_) => {
          onClick?.(options?.[index]);
          setActiveTab(Number(index));
        });
      }
    },
    [arrayOfTabWidth],
  );

  React.useLayoutEffect(() => {
    if (options && wrapperRef?.current) {
      const _clientChildren = wrapperRef?.current?.children;

      if (typeof _clientChildren === "object" && _clientChildren?.length > 0) {
        let _childrenWidth = [];
        let _childrenAccumulativeWidth = 0;

        for (let i = 0; i < options?.length; i++) {
          // @ts-ignore

          _childrenWidth?.push({
            id: i,
            width: _childrenAccumulativeWidth,
            clientWidth: _clientChildren?.[i]?.clientWidth,
          });

          _childrenAccumulativeWidth += _clientChildren?.[i]?.clientWidth;
        }

        averageWidth.current = _childrenAccumulativeWidth / options?.length;

        if (_childrenWidth?.length > 0) setArrayOfTabWidth(_childrenWidth);
      }
    }

    if (options && wrapperRef?.current && isOnModal && isModalVisible) {
      setTimeout(() => {
        const _clientChildren = wrapperRef?.current?.children;

        if (typeof _clientChildren === "object" && _clientChildren?.length > 0) {
          let _childrenWidth = [];
          let _childrenAccumulativeWidth = 0;

          for (let i = 0; i < options?.length; i++) {
            // @ts-ignore

            _childrenWidth?.push({
              id: i,
              width: _childrenAccumulativeWidth,
              clientWidth: _clientChildren?.[i]?.clientWidth,
            });

            _childrenAccumulativeWidth += _clientChildren?.[i]?.clientWidth;
          }

          averageWidth.current = _childrenAccumulativeWidth / options?.length;

          if (_childrenWidth?.length > 0) setArrayOfTabWidth(_childrenWidth);
        }
      }, 500);
    }
  }, [options, isOnModal, isModalVisible]);

  /* Slide when have default index */
  React.useEffect(() => {
    // @ts-ignore
    const _left = Number(arrayOfTabWidth?.[defaultIndex]?.width ?? 0);

    scrollTo({
      top: 0,
      left: _left + defaultIndexCardLeftSpace,
      horizontal: true,
      averageWidth: averageWidth?.current + 10,
      scrollableContainer: wrapperRef?.current,
      /** ketika mendapatkan error ataupun ternyata tab bukan scrolling element maka bisa menggunakan callback ini */
      errorCallback: () => {
        console.log("TEST ERROR", defaultIndex);

        setActiveTab(Number(defaultIndex));
      },
    })?.then((_) => {
      console.log("TEST SUCCESS");

      setActiveTab(Number(defaultIndex));
    });
  }, [defaultIndex, arrayOfTabWidth]);

  return (
    <Container ref={wrapperRef}>
      {options?.map((opt) => {
        const isActive = activeTab === opt?.index;

        console.log({ activeTab });

        return (
          <Item
            inactiveTextColor={inactiveTextColor}
            onClick={() => handleClick(opt?.index)}
            isActive={isActive}
            key={opt?.index}
          >
            <p>{opt?.title}</p>
            {isActive && <Underline />}
          </Item>
        );
      })}
    </Container>
  );
};

export default TabSlider;
